import React, { useState } from "react";
import { Button, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons";

import { appTheme } from "../../../../styling/style";
import { CreateDocumentTagDialog } from "./CreateDocumentTagDialog";

const useStyles = makeStyles((theme) => ({
  addIcon: {
    color: appTheme.colors.primary,
  },
}));

export const CreateDocumentTagButton = (): JSX.Element => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        data-cy="createDocumentTag"
        startIcon={<Add className={classes.addIcon} />}
        onClick={() => setOpen(true)}
        size="small"
      >
        Create document tag
      </Button>
      <CreateDocumentTagDialog
        open={open}
        onClose={() => setOpen(false)}
        isEditing={false}
      />
    </>
  );
};
